module.exports = __webpack_public_path__ + "static/media/scenery.5ebfb5cb.svg";